export const DVEPBabylonSystem = {
    DVERSystem: {},
    system: {},
    $INIT(DVER, system) {
        this.DVERSystem = DVER.babylon.system;
        this.system = system;
    },
};
